import { Box, Typography, SxProps, Theme } from "@mui/material";
import { SectionContainer } from "../../../modules/SectionContainer/SectionContainer";
import { SectionTitle } from "../../../modules/SectionTitle/SectionTitle";

const jobs = [
  {
    title: "アウトソーシング支援",
    description:
      "自動車・食品・航空など大手クライアントの開発現場に入り、多様な業種・規模の案件でエンジニアとしての総合力を磨けます。",
    icon: "🏢",
  },
  {
    title: "受託開発・人材開発支援",
    description:
      "要件定義から開発・運用まで一貫して関われるプロジェクトが多数。設計からリリースまでやり切るスキルが身につきます。",
    icon: "💻",
  },
  {
    title: "自社サービス開発・保守",
    description:
      "約200名が使う社内システムをゼロから設計・開発し継続保守中（開発規模 約1,000万円）。「作って終わり」ではない、改善型の開発を経験できます。",
    icon: "🛠️",
  },
  {
    title: "プログラマーズギルド連携",
    description:
      "自社運営の200名以上のハイレベルエンジニアコミュニティと連携しながら開発。最前線の技術トレンドを取り込める環境があります。",
    icon: "👥",
  },
  {
    title: "幅広い技術スタック",
    description:
      "TypeScript / React / Java / Python / SpringBoot / Flutter / AWS / RDB など、モダンな技術をリアルな大規模案件で経験できます。",
    icon: "⚡",
  },
];

export const JobsSection = () => {
  return (
    <SectionContainer sx={{ background: "#FFFFFF", padding: { md: "100px 0", xs: "60px 0" } }}>
      <SectionTitle sx={{ fontSize: { md: "40px", xs: "26px" } }}>私たちがやること</SectionTitle>

      <Box sx={jobsContainerSx}>
        {jobs.map((job, index) => (
          <Box key={index} sx={jobCardSx}>
            <Typography sx={iconSx}>{job.icon}</Typography>
            <Typography sx={titleSx}>{job.title}</Typography>
            <Typography sx={descriptionSx}>{job.description}</Typography>
          </Box>
        ))}
      </Box>
    </SectionContainer>
  );
};

const jobsContainerSx: SxProps<Theme> = {
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
  gap: { md: "24px", xs: "16px" },
  marginTop: { md: "48px", xs: "32px" },
};

const jobCardSx: SxProps<Theme> = {
  background: "#F8F8F8",
  borderRadius: "12px",
  padding: { md: "32px 28px", xs: "24px 20px" },
  transition: "all 0.3s",
  width: { md: "calc(33.333% - 16px)", xs: "100%" },
  "&:hover": {
    transform: "translateY(-4px)",
    boxShadow: "0 8px 30px rgba(0, 0, 0, 0.08)",
  },
};

const iconSx: SxProps<Theme> = {
  fontSize: { md: "32px", xs: "28px" },
  marginBottom: "16px",
};

const titleSx: SxProps<Theme> = {
  fontSize: { md: "18px", xs: "16px" },
  fontWeight: 700,
  color: "#222222",
  marginBottom: "12px",
};

const descriptionSx: SxProps<Theme> = {
  fontSize: { md: "14px", xs: "13px" },
  color: "#666666",
  lineHeight: 1.8,
};
